"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailAccountImapStateEnum = void 0;
var MailAccountImapStateEnum;
(function (MailAccountImapStateEnum) {
    MailAccountImapStateEnum["None"] = "N";
    MailAccountImapStateEnum["Error"] = "E";
    MailAccountImapStateEnum["Unauthorized"] = "U";
    MailAccountImapStateEnum["Authenticated"] = "A";
    MailAccountImapStateEnum["Connected"] = "C";
    MailAccountImapStateEnum["Connecting"] = "Cn";
    MailAccountImapStateEnum["Disconnected"] = "D";
})(MailAccountImapStateEnum = exports.MailAccountImapStateEnum || (exports.MailAccountImapStateEnum = {}));
